import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "products-details-container" }
const _hoisted_2 = { class: "products-info-item" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = { class: "products-info-item" }
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "products-info-item" }
const _hoisted_7 = { class: "info-value" }
const _hoisted_8 = { class: "products-info-item" }
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = { class: "products-info-item" }
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "products-info-item" }
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = { class: "products-info-item" }
const _hoisted_15 = { class: "info-value" }
const _hoisted_16 = { class: "products-info-item" }
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = { class: "products-info-item" }
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = { class: "products-info-item" }
const _hoisted_21 = { class: "info-value" }
const _hoisted_22 = { class: "products-info-item" }
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = { class: "products-info-item" }
const _hoisted_25 = { class: "info-value" }
const _hoisted_26 = { class: "products-info-item" }
const _hoisted_27 = { class: "info-value" }
const _hoisted_28 = { class: "products-info-item" }
const _hoisted_29 = { class: "info-value" }
const _hoisted_30 = { class: "products-info-item" }
const _hoisted_31 = { class: "info-value" }
const _hoisted_32 = { class: "products-info-item" }
const _hoisted_33 = { class: "info-value" }
const _hoisted_34 = { class: "products-info-item" }
const _hoisted_35 = { class: "info-value" }
const _hoisted_36 = { class: "products-info-item" }
const _hoisted_37 = { class: "info-value" }
const _hoisted_38 = { class: "products-info-item" }
const _hoisted_39 = { class: "info-value" }
const _hoisted_40 = { class: "products-info-item" }
const _hoisted_41 = { class: "info-value" }
const _hoisted_42 = { class: "products-info-item" }
const _hoisted_43 = { class: "info-value" }
const _hoisted_44 = { class: "products-info-item" }
const _hoisted_45 = { class: "info-value" }
const _hoisted_46 = { class: "products-info-item" }
const _hoisted_47 = { class: "info-value" }
const _hoisted_48 = { class: "products-info-item" }
const _hoisted_49 = { class: "info-value" }
const _hoisted_50 = { class: "products-info-item" }
const _hoisted_51 = { class: "info-value" }
const _hoisted_52 = { class: "products-info-item" }
const _hoisted_53 = { class: "info-value" }
const _hoisted_54 = { class: "products-info-item" }
const _hoisted_55 = { class: "info-value" }
const _hoisted_56 = { class: "products-info-item" }
const _hoisted_57 = { class: "info-value" }
const _hoisted_58 = { class: "products-info-item" }
const _hoisted_59 = { class: "info-value" }
const _hoisted_60 = { class: "products-info-item" }
const _hoisted_61 = { class: "info-value" }
const _hoisted_62 = { class: "products-info-item" }
const _hoisted_63 = { class: "info-value" }
const _hoisted_64 = { class: "products-info-item" }
const _hoisted_65 = { class: "info-value" }
const _hoisted_66 = { class: "products-info-item" }
const _hoisted_67 = { class: "info-value" }
const _hoisted_68 = { class: "products-info-item" }
const _hoisted_69 = { class: "info-value" }
const _hoisted_70 = { class: "products-info-item" }
const _hoisted_71 = { class: "info-value" }
const _hoisted_72 = { class: "products-info-item" }
const _hoisted_73 = { class: "info-value" }
const _hoisted_74 = { class: "products-info-item" }
const _hoisted_75 = { class: "info-value" }
const _hoisted_76 = { class: "products-info-item" }
const _hoisted_77 = { class: "info-value" }
const _hoisted_78 = { class: "products-info-item" }
const _hoisted_79 = { class: "info-value" }
const _hoisted_80 = { class: "products-info-item" }
const _hoisted_81 = { class: "info-value" }
const _hoisted_82 = { class: "products-info-item" }
const _hoisted_83 = { class: "info-value" }
const _hoisted_84 = { class: "products-info-item" }
const _hoisted_85 = { class: "info-value" }
const _hoisted_86 = { class: "products-info-item" }
const _hoisted_87 = { class: "info-value" }
const _hoisted_88 = { class: "products-info-item" }
const _hoisted_89 = { class: "info-value" }
const _hoisted_90 = { class: "products-info-item" }
const _hoisted_91 = { class: "info-value" }
const _hoisted_92 = { class: "products-info-item" }
const _hoisted_93 = { class: "info-value" }
const _hoisted_94 = { class: "products-info-item" }
const _hoisted_95 = { class: "info-value" }
const _hoisted_96 = { class: "products-info-item" }
const _hoisted_97 = { class: "info-value" }
const _hoisted_98 = { class: "products-info-item" }
const _hoisted_99 = { class: "info-value" }
const _hoisted_100 = { class: "products-info-item" }
const _hoisted_101 = { class: "info-value" }
const _hoisted_102 = { class: "products-info-item" }
const _hoisted_103 = { class: "info-value" }
const _hoisted_104 = { class: "products-info-item" }
const _hoisted_105 = { class: "info-value" }
const _hoisted_106 = { class: "products-info-item" }
const _hoisted_107 = { class: "info-value" }
const _hoisted_108 = { class: "products-info-item" }
const _hoisted_109 = { class: "info-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxFormItemGrid = _resolveComponent("DxFormItemGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "buttons d-flex justify-start pa-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_DxButton, {
          text: "Înapoi",
          icon: "arrowleft",
          "styling-mode": "contained",
          type: "default",
          class: "back-button",
          onClick: _ctx.goBack
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_DxDataGrid, {
        ref: "dataGrid",
        "data-source": _ctx.dsProduse,
        "show-borders": true,
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "column-resizing-mode": 'nextColumn',
        "hover-state-enabled": true,
        "filter-sync-enabled": true,
        height: "600",
        class: "grid theme-dependent",
        "key-expr": "Id",
        onExporting: _ctx.onExporting,
        "column-width": 100,
        onContextMenuPreparing: _ctx.onContextMenuPreparing,
        "show-row-lines": true,
        onInitNewRow: _ctx.onInitNewRow,
        onEditorPreparing: _ctx.onEditorPreparing,
        onRowInserted: _ctx.onRowInserted,
        onRowUpdated: _ctx.onRowUpdated
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxColumnChooser, {
            enabled: true,
            title: "Selector coloane",
            allowSearch: true,
            sortOrder: "asc"
          }),
          _createVNode(_component_DxPaging, {
            "page-size": 15,
            "page-index": 0
          }),
          _createVNode(_component_DxScrolling, { "column-rendering-mode": "virtual" }),
          _createVNode(_component_DxLoadPanel, {
            enabled: true,
            "indicator-src": 'reload6.gif'
          }),
          _createVNode(_component_DxExport, {
            enabled: true,
            "allow-export-selected-data": true,
            formats: ['xlsx', 'pdf']
          }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxEditing, {
            allowUpdating: true,
            allowAdding: true,
            mode: "popup"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxPopup, {
                closeOnOutsideClick: false,
                showCloseButton: false,
                width: 1500,
                height: 780
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.successButtonOptions
                  }, null, 8, ["options"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.dangerButtonOptions
                  }, null, 8, ["options"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormGrid, { "col-count": 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItemGrid, {
                    "item-type": "group",
                    caption: "Date inițiale",
                    "col-count": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "Cod",
                        label: { text: 'Cod Producător' },
                        "editor-options": { valueChangeEvent: 'input', validationMessageMode: 'always' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule, { message: "Câmpul Cod este obligatoriu." })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "CodIntern",
                        "editor-options": { readOnly: true, placeholder: '#AUTO' }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "Nume",
                        label: { text: 'Denumire' },
                        "editor-type": "dxTextArea",
                        "editor-options": { valueChangeEvent: 'input', validationMessageMode: 'always', height: 142 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule, { message: "Câmpul Denumire este obligatoriu." })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItemGrid, {
                    "item-type": "group",
                    caption: "Prezentare",
                    "col-count": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxFormItemGrid, { dataField: "Producator" }),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "ProducatorTaraId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsTari, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' },
                        label: { text: 'Producator Țara' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "CodNc8id",
                        label: { text: 'Cod NC8' }
                      }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "CodBare" }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "CodCPV" }),
                      _createVNode(_component_DxSimpleItem, {
                        "data-field": "Imagine",
                        template: _ctx.imageUploaderTemplate,
                        label: { text: 'Imagine' }
                      }, null, 8, ["template"]),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "Serviciu",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "Stocabil",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "Url" }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "Marker" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItemGrid, {
                    "item-type": "group",
                    caption: "Stoc",
                    "col-count": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "UnitateId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsUnitati, valueExpr: 'Id', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Bucati' },
                        label: { text: 'UM' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "TipEtichetaId",
                        label: { text: 'Tip Etichetă' }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "SeCantareste",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxFormItem, {
                        dataField: "Activ",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "MasaBuc",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.00######', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "MasaBucNet",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.00######', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "SursaProdus",
                        label: { text: 'Sursă Produs' }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "QavertizareStoc",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.###', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "Qaprovizionare",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.###', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "LocDepozitare" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItemGrid, {
                    "item-type": "group",
                    caption: "Clasificare",
                    "col-count": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "UnitateAmbalajId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsUnitati, valueExpr: 'Id', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' },
                        label: { text: 'UM Ambalaj' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "CantitatePt1Fa",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.###', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "CategorieContabilaId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsCategorieContabila, valueExpr: 'Id', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: '371.01 - Marfuri Gestiunea 01  -XXX' },
                        label: { text: 'Categorie Contabilă' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItem, { dataField: "CategTva" }),
                      _createVNode(_component_DxFormItem, { dataField: "CategTvaMotivScutire" }),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "ClasificatieEconomicaId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsClasificatieEconomica, valueExpr: 'ID', displayExpr: 'Cod', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' },
                        label: { text: 'Clasificație Economică' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "CodD394",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsCoduriD394, valueExpr: 'Nume', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' },
                        label: { text: 'Cod D394' }
                      }, null, 8, ["editor-options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItemGrid, {
                    "item-type": "group",
                    caption: "Comercial",
                    "col-count": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxFormItemGrid, { dataField: "NumeComercial" }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "Descriere" }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "Pret",
                        "editor-type": "dxNumberBox",
                        label: { text: 'Preț' },
                        "editor-options": { format: '#,##0.00####', showSpinButtons: true, min: 0, placeholder: '0' }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "PretVanzare",
                        "editor-type": "dxNumberBox",
                        label: { text: 'Preț Vânzare' },
                        "editor-options": { format: '#,##0.00####', showSpinButtons: true, min: 0, placeholder: '0' }
                      }),
                      _createVNode(_component_DxFormItem, {
                        dataField: "PretVanzareAnterior",
                        "editor-type": "dxNumberBox",
                        label: { text: 'Preț Vânzare Anterior' },
                        "editor-options": { format: '#,##0.00####', showSpinButtons: true, min: 0 }
                      }),
                      _createVNode(_component_DxFormItem, {
                        dataField: "PretVanzareData",
                        "editor-type": "dxDateBox",
                        label: { text: 'Preț Vânzare Dată' },
                        "editor-options": { type: 'date', displayFormat: 'dd.MM.yyyy' }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "PretValutaId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsPretValuta, valueExpr: 'Id', displayExpr: 'Simbol', searchEnabled: true, showClearButton: true, placeholder: 'RON' },
                        label: { text: 'Moneda' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "PretCursBancaId",
                        "editor-type": "dxSelectBox",
                        "editor-options": { dataSource: _ctx.dsBanci, valueExpr: 'ID', displayExpr: 'Cod', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' },
                        label: { text: 'Preț Curs Bancă' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "TvaCurent",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.00####', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "TvaCurentData",
                        "editor-type": "dxDateBox",
                        "editor-options": { value: new Date(), displayFormat: 'dd/MM/yyyy', type: 'date' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "TvaAnterior",
                        "editor-type": "dxNumberBox",
                        "editor-options": { format: '#,##0.00####', min: 0, showSpinButtons: true }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "TaxaVamala",
                        "editor-type": "dxNumberBox",
                        label: { text: 'Taxă Timbru Verde' },
                        "editor-options": { format: '#,##0.00####', showSpinButtons: true, min: 0 }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "TaxareInversa",
                        "editor-type": "dxSwitch",
                        label: { text: 'Taxare Inversă' },
                        "editor-options": { switchedOnText: 'Da', switchedOffText: 'Nu' }
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        dataField: "GarantieLuni",
                        "editor-type": "dxNumberBox",
                        "editor-options": { min: 12, showSpinButtons: true }
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItemGrid, {
                    "item-type": "group",
                    caption: "Marketplace",
                    "col-count": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxFormItemGrid, { dataField: "CodPnk" }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "CodPNKBG" }),
                      _createVNode(_component_DxFormItemGrid, { dataField: "CodPNKHU" }),
                      _createVNode(_component_DxFormItemGrid, {
                        "data-field": "ProdusSgrID",
                        "editor-type": "dxSelectBox",
                        "editor-options": {
                            dataSource: _ctx.dsProduse,
                            valueExpr: 'Id',
                            displayExpr: 'Nume',
                            searchEnabled: true,
                            showClearButton: true,
                            placeholder: 'Selectează'
                        },
                        label: { text: 'Produs SGR' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxFormItem, { dataField: "Compatibilitate" }),
                      _createVNode(_component_DxFormItemGrid, {
                        "item-type": "group",
                        "col-count": 2
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxFormItem, {
                            dataField: "WwwID",
                            "editor-type": "dxNumberBox",
                            "editor-options": { min: 0, showSpinButtons: true }
                          }),
                          _createVNode(_component_DxFormItem, {
                            dataField: "WwwSyncedDate",
                            "editor-type": "dxDateBox",
                            "editor-options": { type: 'datetime', displayFormat: 'dd.MM.yyyy HH:mm' }
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxFormItemGrid, {
                        "item-type": "group",
                        "col-count": 2
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxFormItem, {
                            dataField: "WwwListat",
                            "editor-type": "dxSwitch",
                            "editor-options": { switchedOnText: 'Da', switchedOffText: 'Nu' }
                          }),
                          _createVNode(_component_DxFormItem, {
                            dataField: "WwwVizibil",
                            "editor-type": "dxSwitch",
                            "editor-options": { switchedOnText: 'Da', switchedOffText: 'Nu' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Cod",
            width: 110,
            fixed: true,
            caption: "Cod Producător"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "CodIntern",
            width: 120,
            fixed: true
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Nume",
            width: 450,
            fixed: true,
            "allow-search": true
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Categorie.Nume",
            caption: "Categorie"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "CategorieId",
            visible: false,
            lookup: {
                dataSource: _ctx.dsCategorie,
                valueExpr: 'Id',
                displayExpr: 'Nume'
            }
          }, null, 8, ["lookup"]),
          _createVNode(_component_DxColumn, {
            "data-field": "Unitate.Nume",
            caption: "UM"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UnitateId",
            visible: false,
            lookup: {
                dataSource: _ctx.dsUnitati,
                valueExpr: 'Id',
                displayExpr: 'Nume'
            }
          }, null, 8, ["lookup"]),
          _createVNode(_component_DxColumn, { caption: "Identificare" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "NumeComercial",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Descriere",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodBare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Marker",
                visible: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Clasificare & Contabil" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "CategorieContabila.Nume",
                caption: "Categorie Contabilă",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CategorieContabilaId",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsCategorieContabila,
                    valueExpr: 'Id',
                    displayExpr: 'Nume'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "ClasificatieEconomica.Cod",
                visible: false,
                caption: "Clasificație Economică"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ClasificatieEconomicaId",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsClasificatieEconomica,
                    valueExpr: 'ID',
                    displayExpr: 'Cod'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "TipEtichetaId",
                visible: false,
                caption: "Tip Etichetă"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CoduriD394.Nume",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodD394",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsCoduriD394,
                    valueExpr: 'Nume',
                    displayExpr: 'Nume'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "CategTva",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CategTvaMotivScutire",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodCPV",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodNc8id",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Compatibilitate",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Activ",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "SursaProdus",
                visible: false,
                caption: "Sursă Produs"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Prețuri & Valută" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "Pret",
                caption: "Preț",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretVanzare",
                caption: "Preț Vânzare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretValuta.Simbol",
                caption: "Preț Valută",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretValutaId",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsPretValuta,
                    valueExpr: 'Id',
                    displayExpr: 'Simbol'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "PretCursBanca.Cod",
                caption: "Preț Curs Bancă",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretCursBancaId",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsBanci,
                    valueExpr: 'ID',
                    displayExpr: 'Cod'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "PretVanzareData",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretVanzareAnterior",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TaxareInversa",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TaxaVamala",
                caption: "Taxă Vamală",
                visible: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "TVA" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "TvaCurent",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TvaCurentData",
                "editor-type": "dxDateBox",
                visible: false,
                "editor-options": { displayFormat: 'dd/MM/yyyy', type: 'date' }
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TvaAnterior",
                visible: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Greutate & Măsurare" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "MasaBuc",
                caption: "Masă Bucată",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "MasaBucNet",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "SeCantareste",
                caption: "Se cântărește",
                width: 120,
                visible: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Stoc & Depozit" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "Stocabil",
                "data-type": "boolean",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "QavertizareStoc",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Qaprovizionare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "LocDepozitare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UnitateAmbalaj.Nume",
                caption: "UM FA",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UnitateAmbalajId",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsUnitati,
                    valueExpr: 'Id',
                    displayExpr: 'Nume'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "CantitatePt1Fa",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Serviciu",
                "data-type": "boolean",
                "set-cell-value": _ctx.serviciuSetCellValue,
                visible: false
              }, null, 8, ["set-cell-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Producător & Origine" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "Producator",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProducatorTara.Nume",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProducatorTaraId",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsTari,
                    valueExpr: 'ID',
                    displayExpr: 'Nume'
                }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "GarantieLuni",
                visible: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Web & Media" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "Url",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Imagine",
                visible: false,
                "cell-template": _ctx.cellTemplateImg
              }, null, 8, ["cell-template"]),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwListat",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwVizibil",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwID",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwSyncedDate",
                visible: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Marketplace-uri" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "eMAGID",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "eMAGIDBG",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "eMAGIDHU",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodPnk",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodPNKBG",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodPNKHU",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProdusSgr.Nume",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProdusSgrID",
                visible: false,
                lookup: {
                    dataSource: _ctx.dsProduse,
                    valueExpr: 'Id',
                    displayExpr: 'Nume'
                }
              }, null, 8, ["lookup"])
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Audit" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "UserCreare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "DataCreare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UserModificare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "DataModificare",
                visible: false
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-source", "onExporting", "onContextMenuPreparing", "onInitNewRow", "onEditorPreparing", "onRowInserted", "onRowUpdated"]),
      _createVNode(_component_DxPopupAdd, {
        visible: _ctx.isProductsDetailsVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isProductsDetailsVisible) = $event)),
        "drag-enabled": false,
        "hide-on-outside-click": true,
        "show-close-button": true,
        container: ".dx-viewport",
        width: 800,
        height: 700
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxScrollView, {
            width: "100%",
            height: "100%"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "section-title" }, "Informații produse", -1)),
                  _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "info-label" }, "Cod Producător:", -1)),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectedProducts.Cod || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "info-label" }, "Cod Intern:", -1)),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.selectedProducts.CodIntern || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info-label" }, "Nume:", -1)),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.selectedProducts.Nume || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info-label" }, "Producator:", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.selectedProducts.Producator || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-label" }, "Producator Tara:", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.selectedProducts.ProducatorTara || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info-label" }, "Cod NC8:", -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.selectedProducts.CodNc8id || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "info-label" }, "Cod Bare:", -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.selectedProducts.CodBare || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "info-label" }, "Cod CPV:", -1)),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.selectedProducts.CodCPV || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "info-label" }, "Imagine:", -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.selectedProducts.Imagine || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "info-label" }, "Serviciu:", -1)),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.selectedProducts.Serviciu || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "info-label" }, "Stocabil:", -1)),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedProducts.Stocabil || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "info-label" }, "URL:", -1)),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.selectedProducts.Url || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "info-label" }, "Marker:", -1)),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.selectedProducts.Marker || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "info-label" }, "UM:", -1)),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.selectedProducts.Unitate || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "info-label" }, "Se cântărește:", -1)),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.selectedProducts.SeCantareste || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "info-label" }, "Masa Bucata:", -1)),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.selectedProducts.MasaBuc || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "info-label" }, "MasaBucNet:", -1)),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.selectedProducts.MasaBucNet || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "info-label" }, "Tip Eticheta:", -1)),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.selectedProducts.TipEtichetaId || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "info-label" }, "Sursa Produs:", -1)),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.selectedProducts.SursaProdus || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "info-label" }, "Q Avertizare Stoc:", -1)),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.selectedProducts.QavertizareStoc || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "info-label" }, "QAprovizionare:", -1)),
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.selectedProducts.Qaprovizionare || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "info-label" }, "Loc Depozitare:", -1)),
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.selectedProducts.LocDepozitare || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "info-label" }, "UM FA:", -1)),
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.selectedProducts.UnitateAmbalaj || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "info-label" }, "Cantitate 1 FA:", -1)),
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.selectedProducts.CantitatePt1Fa || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "info-label" }, "Denumire Comerciala:", -1)),
                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.selectedProducts.NumeComercial || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "info-label" }, "Descriere:", -1)),
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.selectedProducts.Descriere || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "info-label" }, "Pret Catalog:", -1)),
                    _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.selectedProducts.Pret), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "info-label" }, "Pret Vanzare:", -1)),
                    _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.selectedProducts.PretVanzare), 1)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "info-label" }, "Pret Valuta:", -1)),
                    _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.selectedProducts.PretValuta || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "info-label" }, "Pret Curs Bancar:", -1)),
                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.selectedProducts.PretCursBanca || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "info-label" }, "%TVA Curent:", -1)),
                    _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.selectedProducts.TvaCurent || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "info-label" }, "Data TVA Curent:", -1)),
                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.selectedProducts.TvaCurentData || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "info-label" }, "TvaAnterior:", -1)),
                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.selectedProducts.TvaAnterior || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "info-label" }, "Taxa Vamala:", -1)),
                    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.selectedProducts.TaxaVamala || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "info-label" }, "Taxare Inversa:", -1)),
                    _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.selectedProducts.TaxareInversa || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "info-label" }, "Garantie (luni):", -1)),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.selectedProducts.GarantieLuni || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "info-label" }, "Categorie Contabila:", -1)),
                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.selectedProducts.CategorieContabila || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "info-label" }, "Clasificatie Economica:", -1)),
                    _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.selectedProducts.ClasificatieEconomica || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "info-label" }, "Cod D394:", -1)),
                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.selectedProducts.CodD394 || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "info-label" }, "Produs SGR:", -1)),
                    _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.selectedProducts.ProdusSgrID || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "info-label" }, "CodPNK:", -1)),
                    _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.selectedProducts.CodPnk || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "info-label" }, "CodPNKBG:", -1)),
                    _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.selectedProducts.CodPNKBG || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "info-label" }, "CodPNKHU:", -1)),
                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.selectedProducts.CodPNKHU || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "info-label" }, "Compatibilitate:", -1)),
                    _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.selectedProducts.Compatibilitate || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "info-label" }, "Pret Vanzare Data:", -1)),
                    _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.selectedProducts.PretVanzareData || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "info-label" }, "Pret Vanzare Anterior:", -1)),
                    _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.selectedProducts.PretVanzareAnterior || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "info-label" }, "Categorie TVA:", -1)),
                    _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.selectedProducts.CategTva || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "info-label" }, "Categorie TVA Motiv Scutire:", -1)),
                    _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.selectedProducts.CategTvaMotivScutire || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "info-label" }, "Activ:", -1)),
                    _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.selectedProducts.Activ || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "info-label" }, "WwwListat:", -1)),
                    _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.selectedProducts.WwwListat || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "info-label" }, "WwwVizibil:", -1)),
                    _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.selectedProducts.WwwVizibil || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "info-label" }, "WwwID:", -1)),
                    _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.selectedProducts.WwwID || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "info-label" }, "WwwSyncedDate:", -1)),
                    _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.selectedProducts.WwwSyncedDate || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "info-label" }, "Categorie:", -1)),
                    _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.selectedProducts.Categorie || '-'), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}